import { IAllocationClientsByGroup } from '~/services/api/clientAllocation/types';

const extractLocationGroupClientsIds = (
  locationGroups: IAllocationClientsByGroup[],
  id: number,
): number[] =>
  locationGroups.find(item => item.locationGroup.id === id).clients.map(client => client.id);

export default extractLocationGroupClientsIds;
